import { createApp } from "vue";

import App from "@/App.vue";
import { configureApp } from "@/app-setup";
import { preloadRuntimeData } from "@/bootstrap";

// Global CSS is imported by each ENTRY POINT rather than by `configureApp`, so
// the federated entry can control exactly what lands in a host's document
// (Tailwind, the reset and the component library all ship page-level selectors).
import "@/assets/main.css";
// Page-level styles (html/body/#app/reset) — standalone entry ONLY. Guarded so
// they stop matching in a host document; see the file header.
import "@/assets/standalone-page.css";
import "@marcoschulte/vue3-progress/style";
import "tippy.js/dist/tippy.css";

// Standalone only: index.html has already run the classic <script> tags that set
// window.__RUNTIME_CONFIG__ / __FLAGS__, so the config is present by now.
preloadRuntimeData();

const app = createApp(App);
configureApp(app);
app.mount("#app");

export default {};
